// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".json-editor[data-v-03d4ca30] {\n  height: 100%;\n  position: relative;\n}\n.json-editor[data-v-03d4ca30]  .CodeMirror {\n  height: auto;\n  min-height: 300px;\n}\n.json-editor[data-v-03d4ca30]  .CodeMirror-scroll {\n  min-height: 300px;\n}\n.json-editor[data-v-03d4ca30]  .cm-s-rubyblue span.cm-string {\n  color: #F08047;\n}", ""]);
// Exports
module.exports = exports;
